// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/img-login.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #F6F9FF;
}



/**** Definições container conteudo ****/
.geral {
  width: 100%;
  height: auto;
  background-color: #F6F9FF;;
}
.container-navbar {
  padding: 24px;
}
.hero.is-small .hero-body {
  background-color: #fff;
 } 



.conteudo {
   margin-left: 20rem;
  min-height: 100vh;
}


/**** Menu ****/
.menu-brand {
    padding: 24px 0 16px 0;
}
.menu-brand a {
  padding: 0 0.75rem;
}
.sidebar .menu ul.menu-list li a {
  color: white;
  font-weight: 400;
}
.sidebar{
   margin: 0;
  padding: 0;
  width: 20rem;
  background-color: #1F395E;
  position: fixed;
  height: 100%;
  overflow: auto;
}
.sidebar .navbar-brand, .navbar-tabs {
  display: block;
}
.sidebar .menu-brand .navbar-burguer {
  display: none;
}
.menu {
  margin-top: 24px;
}
.sidebar .menu .menu-label {
  padding: 0 0.75rem;
  margin-top: 32px;
  color: #FFF000;
}
.menu .menu-list a {
  padding: 0.5rem 0.75rem;
}
.menu .menu-list a:hover {
  border-radius: 12px;
}
.menu .menu-list a.is-active {
  color: #AFDEDC !important;
  border-radius: 12px;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
 .navbar-burguer {
    display: block;
  } 
  div.conteudo {margin-left: 0;}  
  .menu {
    display: none;
  }
  .menu.is-active {
    display: block;
  }
  .menu-brand {
    padding: 0;
  }
  .sidebar .menu-brand .navbar-burger {
    display: block;
    position: relative;
    float: right;
    color: white;
    right: 0;
  }
  .menu-brand a {
    padding: 0;
  }
  .container-navbar {
    padding: 16px;
  }

  }
 input {
  margin-right: 8px;
 }
/**** login ****/

body .login {
  width: 100vw;
  height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  position: absolute;
}
body .login .login-side {
  background-color: #FFFFFF;
  height: 100vh;
  width: 30rem;
  padding: 1.5rem;
 z-index: 10;
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 1.5rem 1.5rem;
  }  
  .section.logo {
    padding: 3rem 0.75rem;
  }
}
@media screen and (max-width: 700px) {
  body .login .login-side {
    width: 100%;
  }
  .section.logo {
    padding: 3rem 0.75rem;
  }
  img.user-image {
        display: none;
    }
  
}  
body .login .columns {
  margin: 0;
}

.column {
  max-width: 1600px;
}
body .login .logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
/*** abrir actividade ***/
.payments {
  margin: 16px 0 16px 0;
}
.payments .logo-payment {
  position: fixed;
  margin-top: -14px;
}
.space-list li {
  margin-bottom: 8px;
}
.light {
  border-bottom: 1px solid #F3F3F3;
  padding: 2.5rem 0;
}

.sample {
  padding: 2.5rem 0 0 0;
}
.spacer-input {
  margin-top: 10px;
}
.credencial .exist {
  padding: 16px;
  border: 1px solid #F3F3F3;
  background-color: #FDFDFD;
}
.teamCard {
  display: inline-block;
  width: 20em;
  min-width: 250px;
  margin: 0 1em 0 0;
}

.faqbox {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  color: #4a4a4a;
  display: block;
  padding: 0.65rem;
  justify-content: center;
}

.newsCard{
  display: inline-block;
  height: 210px;
  min-width: 310px;
  width: 360px;
  margin: 0 1em 0 0;
}

.newsCard-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.newsCard-date {
  color: white;
}

.newsCard-title{
  color: #FFF000
}

.credencial .inloco .teamblock {
  display: flex;
}
.credencial .inloco span.tag {
  margin-left: 8px;
}
.info {
  background-color: #ecf8f8;
}
/*** credenciais ***/
.credencial-style .column {
  margin: 15px;
  padding: 32px;
}
.credencial-style .exist {
  padding: 32px;
  background-color: white;
  border-radius: 12px;
  border: 1px #ECECEC solid;
}

.credencial-style .inloco .teamblock{
  display: flex;
}
.credencial-style .inloco span.tag {
  margin-left: 8px;
}
/*** Tabs ***/
  #tabs-with-content .tabs:not(:last-child) {
  margin-bottom: 0;
}
#tabs-with-content .tab-content {
  padding: 1rem;
  display: none;
}
#tabs-with-content .tab-content.is-active {
  display: block;
}
/*** Button ***/

.button.btn1 {
    font-size: 0.8rem;
    padding: 20px 35px;
    text-transform: uppercase;
}

.is-visible{
  display: initial !important;
}

.scrollable-table{
  max-height: 200px;
  overflow-y:scroll
}
.fine-print{
  font-size: 11px;
}

.underline{
  text-decoration: underline;
}

.button:active, .button.is-active {
  border-color: #1F395E;
  color: #1F395E;
}

.geral article.message {
  margin-bottom: 1.5rem;
}





/*** Estilos Abilio ***/

.box-footsolution {
  padding: 32px;
  background-color: white;
  border-radius: 12px;
  border: 1px #ECECEC solid;
}
.box-footsolution.extra {
  background: none;
  border-color: #ECECEC;
  color: black;
}

.label {
  font-weight: 400;
}

.hero.is-footsolution {
    padding-bottom: 32px;
}

.textarea.is-footsolution {
  border: none;
    overflow: auto;
    outline: none;
    padding: 0;
    box-shadow: none;
    margin-top: 10px;
    resize: none; /*remove the resize handle on the bottom right*/
}

.input.is-footsolution {
   border: none;
    overflow: auto;
    outline: none;
    padding: 0;
    box-shadow: none;
    margin-top: 10px;
    resize: none; /*remove the resize handle on the bottom right*/
}

.extra li {
  margin-bottom: 16px;
}

 .is-end {
  float: right;
 }

/*** Case list ***/

 .tag.is-footsolution {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 17px;
  color: white;
 }

.tag.is-new, .is-new {
  background-color: #219ebc;
}

.tag.is-open, .is-open {
  background-color: #2a9d8f;
}

.tag.is-closed, .is-closed {
  background-color: #8d99ae;
}
.ticket-number {
  border: 1px solid #D9D9D9;
  border-radius: 100px;
  font-weight: 800;
  padding: 4px 8px 4px 8px;
  

}

.ident-ticket {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
}

.ident-ticket .comments {
  margin-left: 8px;
}
.ident-ticket time {
  font-weight: 700;
}

.ident-ticket .ticket-number {
  margin-left: 8px;
} 

.list .box-footsolution {
  margin-bottom: 16px;
}

.border-line {
  border: 1px solid #E8E6E6;
  margin-top: 8px;
  margin-bottom: 24px;
}

.container-counter {
  margin-bottom: 16px;
}

.container-counter li {
  margin-bottom: 16px;
}



space {
  margin-left: 4px;
} 

.container-counter p {
  font-size: 16px;
  font-weight: 500;
  color: black;
}

.counter-number {
  border-radius: 100px;
  font-weight: 500;
  padding: 4px 11px 4px 11px;
  color: white;

}

.body-messagem {
  margin-top: 32px;
}

.body-messagem.show-ticket {
  margin-top: 0;
}

.textarea.is-footsolution {
  border: none;
    overflow: auto;
    outline: none;
    padding: 0;
    box-shadow: none;

    resize: none; /*remove the resize handle on the bottom right*/
}

.is-right {
  text-align: right;
  display: block;
}

.anexos a {
  text-decoration: underline;
}

.body-form .buttons {
  margin-top: 40px;
}

a.box-link p {
  text-decoration: none;
  color: black;
}

@keyframes link {
  0%   {background-color:#edf6f9; left:0px; top:0px;}
  25%  {background-color:#edf6f9; left:200px; top:0px;}
  50%  {background-color:#edf6f9; left:200px; top:200px;}
  75%  {background-color:#edf6f9; left:0px; top:200px;}
  100% {background-color:#edf6f9; left:0px; top:0px;}
}

a.box-link .box-footsolution:hover {
  background-color: #edf6f9 ;
  animation-duration: 2s;
  animation-name: link;
  cursor: pointer;
}

.align-badge {
  margin-top: 6px;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background-size: cover;
}

.balon {
  padding: 32px;
}

.dialog-client .balon {
  border-radius: 12px 0px 12px 12px;
  background-color: black;
  color: white;
}

.dialog-footsolution .balon {
  border-radius: 0px 12px 12px 12px;
  background-color: #8589C0;
  color: white;
}

.balon .anexos {
  margin-top: 24px;
}

.balon .anexos a {
  color: white;
}

.sign {
  margin-top: 16px;
}

.sign p {
  font-size: 12px;
  color: black;
}

.pointable{
  cursor: pointer
}

.dropdown-item:hover {
  background-color: #1F395E;
  color:white;
}

.teams {
  width: 20em;
}

.circled-icon {
  display: inline-block;
  border-radius: 60px;
  box-shadow: 0 0 2px #888;
  padding: 0.5em 0.6em;
}

.invisible-box{
  text-align: center;
}


.fullwidth{
  width: 100% !important;
}
.flex {
  display: flex
}

.marginAuto {
  margin: auto
}

.bold {
  font-weight: bold
}

.table {
  background-color: transparent !important;
}

.gameCSS{
  background-color: #1F395E !important;
  color: white !important;
 }

.trainingCSS{
  background-color:#F39237 !important;
}

.otherCSS{
  background-color:#AFDEDC !important;
}

.vacancy{
  width: 200px;
  height: 100px;
  background-color: #F5F5F5;
  border-radius: 10px;
  margin: 0 15px;
}

.vacancy-header-header{
  font-size: 45px;
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
}

.vacancy-header-text{
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
}

.team-member-detail{
  min-width: 185px;
  background-color: #FFFFFF;
  border-radius: 25px;
  margin: 10px 15px;
}

.team-member-image{
  width: 200px;
  height: 175px;
  border-radius: 70px;
}

.team-member-text {
  font-weight: 900;
  text-align: right;
  margin-right: 15px;
  display:flex;
  justify-content: space-between;
}

.team-member-name {
  max-height: 20px;
  padding: 0 20px;
  width: 100%;
}


.flexWrap {
  display: flex;
  flex-wrap: wrap;
}

.team-member-number {
  font-weight: 900;
  text-align: right;
  font-size: 400%;
  display:relative;
  margin-top: -53px;
  color: #D2D0D0;
}

.calendar-style {
  border: 0px !important;
  border-radius: 15px;
}

.header {
  color: #1F395E
}

.react-datepicker__year-dropdown .react-datepicker__year-option:first-child::before {
  content: "\\25B2";
  position: absolute;
  top: 5%;
  left: 45%;
  margin: auto;
}

.react-datepicker__year-dropdown::after {
  content: "\\25BC";
  display: block;
  position: relative;
  bottom: 15%;
}

.top-add {
  height: auto;
  width: 100%;
}

.top-img {
  height: auto;
  width: 100%;
  max-height: 215px;
  min-height: 150px;
}

.right-add {
  height: 100vh;
  width: auto;
}

.right-img {
  height: 86vh;
  max-width: 150px;
  width: auto;
}

.dashboard{
  width: 85%;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;;;AAIA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;CACvB;;;;AAID;GACG,kBAAkB;EACnB,iBAAiB;AACnB;;;AAGA,eAAe;AACf;IACI,sBAAsB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;GACG,SAAS;EACV,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;CACD;IACG,cAAc;EAChB;EACA,cAAc,cAAc,CAAC;EAC7B;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;;EAEA;CACD;EACC,iBAAiB;CAClB;AACD,gBAAgB;;AAEhB;EACE,YAAY;EACZ,aAAa;EACb,mDAAuC;EACvC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,eAAe;CAChB,WAAW;AACZ;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;QACM,aAAa;IACjB;;AAEJ;AACA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA,yBAAyB;AACzB;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0FAA0F;EAC1F,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA,oBAAoB;AACpB;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA,aAAa;EACX;EACA,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA,eAAe;;AAEf;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB;AACF;AACA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;;;;;AAMA,uBAAuB;;AAEvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;EACE,YAAY;IACV,cAAc;IACd,aAAa;IACb,UAAU;IAGV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY,EAAE,+CAA+C;AACjE;;AAEA;GACG,YAAY;IACX,cAAc;IACd,aAAa;IACb,UAAU;IAGV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY,EAAE,+CAA+C;AACjE;;AAEA;EACE,mBAAmB;AACrB;;CAEC;EACC,YAAY;CACb;;AAED,kBAAkB;;CAEjB;EACC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;CACb;;AAED;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;;;AAG1B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;;AAEd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;IACV,cAAc;IACd,aAAa;IACb,UAAU;IAGV,gBAAgB;;IAEhB,YAAY,EAAE,+CAA+C;AACjE;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,MAAM,wBAAwB,EAAE,QAAQ,EAAE,OAAO,CAAC;EAClD,MAAM,wBAAwB,EAAE,UAAU,EAAE,OAAO,CAAC;EACpD,MAAM,wBAAwB,EAAE,UAAU,EAAE,SAAS,CAAC;EACtD,MAAM,wBAAwB,EAAE,QAAQ,EAAE,SAAS,CAAC;EACpD,MAAM,wBAAwB,EAAE,QAAQ,EAAE,OAAO,CAAC;AACpD;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;AACxB;AACA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;CACxB;;AAED;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body {\n  background-color: #F6F9FF;\n}\n\n\n\n/**** Definições container conteudo ****/\n.geral {\n  width: 100%;\n  height: auto;\n  background-color: #F6F9FF;;\n}\n.container-navbar {\n  padding: 24px;\n}\n.hero.is-small .hero-body {\n  background-color: #fff;\n } \n\n\n\n.conteudo {\n   margin-left: 20rem;\n  min-height: 100vh;\n}\n\n\n/**** Menu ****/\n.menu-brand {\n    padding: 24px 0 16px 0;\n}\n.menu-brand a {\n  padding: 0 0.75rem;\n}\n.sidebar .menu ul.menu-list li a {\n  color: white;\n  font-weight: 400;\n}\n.sidebar{\n   margin: 0;\n  padding: 0;\n  width: 20rem;\n  background-color: #1F395E;\n  position: fixed;\n  height: 100%;\n  overflow: auto;\n}\n.sidebar .navbar-brand, .navbar-tabs {\n  display: block;\n}\n.sidebar .menu-brand .navbar-burguer {\n  display: none;\n}\n.menu {\n  margin-top: 24px;\n}\n.sidebar .menu .menu-label {\n  padding: 0 0.75rem;\n  margin-top: 32px;\n  color: #FFF000;\n}\n.menu .menu-list a {\n  padding: 0.5rem 0.75rem;\n}\n.menu .menu-list a:hover {\n  border-radius: 12px;\n}\n.menu .menu-list a.is-active {\n  color: #AFDEDC !important;\n  border-radius: 12px;\n}\n\n@media screen and (max-width: 700px) {\n  .sidebar {\n    width: 100%;\n    height: auto;\n    position: relative;\n  }\n .navbar-burguer {\n    display: block;\n  } \n  div.conteudo {margin-left: 0;}  \n  .menu {\n    display: none;\n  }\n  .menu.is-active {\n    display: block;\n  }\n  .menu-brand {\n    padding: 0;\n  }\n  .sidebar .menu-brand .navbar-burger {\n    display: block;\n    position: relative;\n    float: right;\n    color: white;\n    right: 0;\n  }\n  .menu-brand a {\n    padding: 0;\n  }\n  .container-navbar {\n    padding: 16px;\n  }\n\n  }\n input {\n  margin-right: 8px;\n }\n/**** login ****/\n\nbody .login {\n  width: 100vw;\n  height: 100vh;\n  background: url('../img/img-login.jpg');\n  background-size: cover;\n  position: absolute;\n}\nbody .login .login-side {\n  background-color: #FFFFFF;\n  height: 100vh;\n  width: 30rem;\n  padding: 1.5rem;\n z-index: 10;\n}\n@media screen and (min-width: 1024px) {\n  .section {\n    padding: 1.5rem 1.5rem;\n  }  \n  .section.logo {\n    padding: 3rem 0.75rem;\n  }\n}\n@media screen and (max-width: 700px) {\n  body .login .login-side {\n    width: 100%;\n  }\n  .section.logo {\n    padding: 3rem 0.75rem;\n  }\n  img.user-image {\n        display: none;\n    }\n  \n}  \nbody .login .columns {\n  margin: 0;\n}\n\n.column {\n  max-width: 1600px;\n}\nbody .login .logo {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n/*** abrir actividade ***/\n.payments {\n  margin: 16px 0 16px 0;\n}\n.payments .logo-payment {\n  position: fixed;\n  margin-top: -14px;\n}\n.space-list li {\n  margin-bottom: 8px;\n}\n.light {\n  border-bottom: 1px solid #F3F3F3;\n  padding: 2.5rem 0;\n}\n\n.sample {\n  padding: 2.5rem 0 0 0;\n}\n.spacer-input {\n  margin-top: 10px;\n}\n.credencial .exist {\n  padding: 16px;\n  border: 1px solid #F3F3F3;\n  background-color: #FDFDFD;\n}\n.teamCard {\n  display: inline-block;\n  width: 20em;\n  min-width: 250px;\n  margin: 0 1em 0 0;\n}\n\n.faqbox {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);\n  color: #4a4a4a;\n  display: block;\n  padding: 0.65rem;\n  justify-content: center;\n}\n\n.newsCard{\n  display: inline-block;\n  height: 210px;\n  min-width: 310px;\n  width: 360px;\n  margin: 0 1em 0 0;\n}\n\n.newsCard-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  margin-bottom: 0px;\n  margin-left: auto;\n  margin-right: auto;\n  align-items: center;\n}\n\n.newsCard-date {\n  color: white;\n}\n\n.newsCard-title{\n  color: #FFF000\n}\n\n.credencial .inloco .teamblock {\n  display: flex;\n}\n.credencial .inloco span.tag {\n  margin-left: 8px;\n}\n.info {\n  background-color: #ecf8f8;\n}\n/*** credenciais ***/\n.credencial-style .column {\n  margin: 15px;\n  padding: 32px;\n}\n.credencial-style .exist {\n  padding: 32px;\n  background-color: white;\n  border-radius: 12px;\n  border: 1px #ECECEC solid;\n}\n\n.credencial-style .inloco .teamblock{\n  display: flex;\n}\n.credencial-style .inloco span.tag {\n  margin-left: 8px;\n}\n/*** Tabs ***/\n  #tabs-with-content .tabs:not(:last-child) {\n  margin-bottom: 0;\n}\n#tabs-with-content .tab-content {\n  padding: 1rem;\n  display: none;\n}\n#tabs-with-content .tab-content.is-active {\n  display: block;\n}\n/*** Button ***/\n\n.button.btn1 {\n    font-size: 0.8rem;\n    padding: 20px 35px;\n    text-transform: uppercase;\n}\n\n.is-visible{\n  display: initial !important;\n}\n\n.scrollable-table{\n  max-height: 200px;\n  overflow-y:scroll\n}\n.fine-print{\n  font-size: 11px;\n}\n\n.underline{\n  text-decoration: underline;\n}\n\n.button:active, .button.is-active {\n  border-color: #1F395E;\n  color: #1F395E;\n}\n\n.geral article.message {\n  margin-bottom: 1.5rem;\n}\n\n\n\n\n\n/*** Estilos Abilio ***/\n\n.box-footsolution {\n  padding: 32px;\n  background-color: white;\n  border-radius: 12px;\n  border: 1px #ECECEC solid;\n}\n.box-footsolution.extra {\n  background: none;\n  border-color: #ECECEC;\n  color: black;\n}\n\n.label {\n  font-weight: 400;\n}\n\n.hero.is-footsolution {\n    padding-bottom: 32px;\n}\n\n.textarea.is-footsolution {\n  border: none;\n    overflow: auto;\n    outline: none;\n    padding: 0;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n    margin-top: 10px;\n    resize: none; /*remove the resize handle on the bottom right*/\n}\n\n.input.is-footsolution {\n   border: none;\n    overflow: auto;\n    outline: none;\n    padding: 0;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n    margin-top: 10px;\n    resize: none; /*remove the resize handle on the bottom right*/\n}\n\n.extra li {\n  margin-bottom: 16px;\n}\n\n .is-end {\n  float: right;\n }\n\n/*** Case list ***/\n\n .tag.is-footsolution {\n  font-family: 'Montserrat', sans-serif;\n  font-style: normal;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 17px;\n  color: white;\n }\n\n.tag.is-new, .is-new {\n  background-color: #219ebc;\n}\n\n.tag.is-open, .is-open {\n  background-color: #2a9d8f;\n}\n\n.tag.is-closed, .is-closed {\n  background-color: #8d99ae;\n}\n.ticket-number {\n  border: 1px solid #D9D9D9;\n  border-radius: 100px;\n  font-weight: 800;\n  padding: 4px 8px 4px 8px;\n  \n\n}\n\n.ident-ticket {\n  font-family: 'Montserrat', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 17px;\n}\n\n.ident-ticket .comments {\n  margin-left: 8px;\n}\n.ident-ticket time {\n  font-weight: 700;\n}\n\n.ident-ticket .ticket-number {\n  margin-left: 8px;\n} \n\n.list .box-footsolution {\n  margin-bottom: 16px;\n}\n\n.border-line {\n  border: 1px solid #E8E6E6;\n  margin-top: 8px;\n  margin-bottom: 24px;\n}\n\n.container-counter {\n  margin-bottom: 16px;\n}\n\n.container-counter li {\n  margin-bottom: 16px;\n}\n\n\n\nspace {\n  margin-left: 4px;\n} \n\n.container-counter p {\n  font-size: 16px;\n  font-weight: 500;\n  color: black;\n}\n\n.counter-number {\n  border-radius: 100px;\n  font-weight: 500;\n  padding: 4px 11px 4px 11px;\n  color: white;\n\n}\n\n.body-messagem {\n  margin-top: 32px;\n}\n\n.body-messagem.show-ticket {\n  margin-top: 0;\n}\n\n.textarea.is-footsolution {\n  border: none;\n    overflow: auto;\n    outline: none;\n    padding: 0;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n\n    resize: none; /*remove the resize handle on the bottom right*/\n}\n\n.is-right {\n  text-align: right;\n  display: block;\n}\n\n.anexos a {\n  text-decoration: underline;\n}\n\n.body-form .buttons {\n  margin-top: 40px;\n}\n\na.box-link p {\n  text-decoration: none;\n  color: black;\n}\n\n@keyframes link {\n  0%   {background-color:#edf6f9; left:0px; top:0px;}\n  25%  {background-color:#edf6f9; left:200px; top:0px;}\n  50%  {background-color:#edf6f9; left:200px; top:200px;}\n  75%  {background-color:#edf6f9; left:0px; top:200px;}\n  100% {background-color:#edf6f9; left:0px; top:0px;}\n}\n\na.box-link .box-footsolution:hover {\n  background-color: #edf6f9 ;\n  animation-duration: 2s;\n  animation-name: link;\n  cursor: pointer;\n}\n\n.align-badge {\n  margin-top: 6px;\n}\n\n.user-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  background-size: cover;\n}\n\n.balon {\n  padding: 32px;\n}\n\n.dialog-client .balon {\n  border-radius: 12px 0px 12px 12px;\n  background-color: black;\n  color: white;\n}\n\n.dialog-footsolution .balon {\n  border-radius: 0px 12px 12px 12px;\n  background-color: #8589C0;\n  color: white;\n}\n\n.balon .anexos {\n  margin-top: 24px;\n}\n\n.balon .anexos a {\n  color: white;\n}\n\n.sign {\n  margin-top: 16px;\n}\n\n.sign p {\n  font-size: 12px;\n  color: black;\n}\n\n.pointable{\n  cursor: pointer\n}\n\n.dropdown-item:hover {\n  background-color: #1F395E;\n  color:white;\n}\n\n.teams {\n  width: 20em;\n}\n\n.circled-icon {\n  display: inline-block;\n  border-radius: 60px;\n  box-shadow: 0 0 2px #888;\n  padding: 0.5em 0.6em;\n}\n\n.invisible-box{\n  text-align: center;\n}\n\n\n.fullwidth{\n  width: 100% !important;\n}\n.flex {\n  display: flex\n}\n\n.marginAuto {\n  margin: auto\n}\n\n.bold {\n  font-weight: bold\n}\n\n.table {\n  background-color: transparent !important;\n}\n\n.gameCSS{\n  background-color: #1F395E !important;\n  color: white !important;\n }\n\n.trainingCSS{\n  background-color:#F39237 !important;\n}\n\n.otherCSS{\n  background-color:#AFDEDC !important;\n}\n\n.vacancy{\n  width: 200px;\n  height: 100px;\n  background-color: #F5F5F5;\n  border-radius: 10px;\n  margin: 0 15px;\n}\n\n.vacancy-header-header{\n  font-size: 45px;\n  margin: auto;\n  width: fit-content;\n}\n\n.vacancy-header-text{\n  margin: auto;\n  width: fit-content;\n}\n\n.team-member-detail{\n  min-width: 185px;\n  background-color: #FFFFFF;\n  border-radius: 25px;\n  margin: 10px 15px;\n}\n\n.team-member-image{\n  width: 200px;\n  height: 175px;\n  border-radius: 70px;\n}\n\n.team-member-text {\n  font-weight: 900;\n  text-align: right;\n  margin-right: 15px;\n  display:flex;\n  justify-content: space-between;\n}\n\n.team-member-name {\n  max-height: 20px;\n  padding: 0 20px;\n  width: 100%;\n}\n\n\n.flexWrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.team-member-number {\n  font-weight: 900;\n  text-align: right;\n  font-size: 400%;\n  display:relative;\n  margin-top: -53px;\n  color: #D2D0D0;\n}\n\n.calendar-style {\n  border: 0px !important;\n  border-radius: 15px;\n}\n\n.header {\n  color: #1F395E\n}\n\n.react-datepicker__year-dropdown .react-datepicker__year-option:first-child::before {\n  content: \"\\25B2\";\n  position: absolute;\n  top: 5%;\n  left: 45%;\n  margin: auto;\n}\n\n.react-datepicker__year-dropdown::after {\n  content: \"\\25BC\";\n  display: block;\n  position: relative;\n  bottom: 15%;\n}\n\n.top-add {\n  height: auto;\n  width: 100%;\n}\n\n.top-img {\n  height: auto;\n  width: 100%;\n  max-height: 215px;\n  min-height: 150px;\n}\n\n.right-add {\n  height: 100vh;\n  width: auto;\n}\n\n.right-img {\n  height: 86vh;\n  max-width: 150px;\n  width: auto;\n}\n\n.dashboard{\n  width: 85%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
